import { administrationRequests } from "api/administrationApi";
import { studentRequests } from "api/studentApi";
import AutoPickSelectInput from "server/components/Fields/AutoPickSelectInput";
import React from "react";
import { ReferenceInput, required, SelectInput } from "react-admin";
import { NationalityType } from "utils/choices";

// At least one of nationality / instruction language must be chosen (both are allowed).
const requireNationalityOrLanguage = (_, allValues) =>
  allValues?.nationalityType || allValues?.instructionLanguageId
    ? undefined
    : "Изберете поне едно от Националност или Език на обучение";

const UnpaidSemesterFees = ({ handleParamChange }) => {
  return (
    <>
      <ReferenceInput
        reference={administrationRequests.getStructuralUnitsSelect()}
        source="structuralUnitId"
        filter={{ filterByUser: true }}
      >
        <AutoPickSelectInput
          source="structuralUnitId"
          label="Факултет"
          validate={required()}
          emptyText={false}
          onValueChange={v => handleParamChange("structuralUnitId", v)}
        />
      </ReferenceInput>

      <ReferenceInput
        source="academicYearId"
        reference={studentRequests.getAcademicYearsSelect()}
      >
        <SelectInput
          label="Учебна година"
          validate={required()}
          emptyText={false}
          onChange={e => handleParamChange("academicYearId", e.target.value)}
        />
      </ReferenceInput>
      <ReferenceInput
        source="semesterType"
        resource={studentRequests.getAcademicSessionTypesSelect()}
        reference={studentRequests.getAcademicSessionTypesSelect()}
        filter={{ SemestersOnly: true }}
      >
        <SelectInput
          label="Семестър"
          validate={required()}
          onChange={e => handleParamChange("semesterType", e.target.value)}
        />
      </ReferenceInput>
      <SelectInput
        source="nationalityType"
        label="Националност"
        choices={NationalityType}
        validate={requireNationalityOrLanguage}
        onChange={e => handleParamChange("nationalityType", e.target.value)}
      />
      <ReferenceInput
        source="instructionLanguageId"
        reference={administrationRequests.getInstructionLanguagesSelect()}
      >
        <SelectInput
          label="Език на обучение"
          validate={requireNationalityOrLanguage}
          onChange={e => handleParamChange("instructionLanguageId", e.target.value)}
        />
      </ReferenceInput>
    </>
  );
};

export default UnpaidSemesterFees;
